<template>
  <div>
    <div class="point" ref="point">
      <slot name="tab-point"></slot>
    </div>
    <div class="content" ref="content">
      <slot name="tab-content"></slot>
    </div>
  </div>
</template>
<script>
import { addClass, removeClass } from '../../common/dom'
export default {
  data() {
    return {
      active: 0
    }
  },
  mounted() {
    let { point,content } = this.$refs ;
    if( point.children.length <= 0 || content.children.length  <= 0 ) return
    let pointChilds = point.children ? point.children[0].children : point.children ,
      contentChilds = content.children ? content.children[0].children : content.children
    this.tabCount = pointChilds.length
    //给每个point item 加上index
    for(let i = 0; i < pointChilds.length ; i++){
      let el = pointChilds[i]
      el.style.cursor = 'pointer'
      el.setAttribute("data-index",i)
      el.addEventListener('click',this.handleItemClick)
    }
    //默认第一个tab content 才渲染
    pointChilds[0] && addClass(pointChilds[0], 'active')
    //给第一个添加Class active
    for(let i = 1; i < contentChilds.length ; i++){
      let el = contentChilds[i]
      el.style.display = 'none'
    }
    this.pointChilds = pointChilds
    this.contentChilds = contentChilds
  },
  methods:{
    handleItemClick(e){
      let index = parseInt( e.currentTarget.getAttribute( 'data-index' ) ),
        content = this.contentChilds[index]
      this.contentChilds[this.active].style.display = 'none'
      // 移除active class
      removeClass(this.pointChilds[this.active], 'active')
      content.style.display = 'block'
      this.active = index
      // 给新的添加active
      addClass(this.pointChilds[this.active], 'active')
      this.$emit("tab",index)
    },
    showAll(flag){
      let display = flag ? 'block' : 'none',
        contentChilds = this.contentChilds
      for(let i = 0, length = contentChilds.length; i < length; i++){
        let c = contentChilds[i]
        c.style.display = display
      }

      if(!flag){
        this.active = 0;
        contentChilds[0].style.display = 'block'
      }
    },
    tab(index){
      this.pointChilds[index].click()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/apps/zcx/components/common/tab.vue